<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="订单名称">
            <el-input
              v-model="queryForm.order_name"
              placeholder="请输入订单名称"
              style="width: 187px"
              clearable
            />
          </el-form-item>
          <el-form-item label="卡牌名称">
            <el-input
              v-model="queryForm.card_name"
              placeholder="请输入卡牌名称"
              style="width: 187px"
              clearable
            />
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
              v-model="queryForm.dateRange"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="dateChange"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="queryForm.status"
              clearable
              filterable
              placeholder="请选择订单状态"
            >
              <el-option
                v-for="item in orderList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="进度">
            <el-select
              v-model="queryForm.is_complete"
              clearable
              filterable
              placeholder="请选择订单进度"
            >
              <el-option
                v-for="item in completeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
            <el-button @click="handleAdd" icon="el-icon-plus" type="success" v-hasPermi="['Island:chipmanage:add']"
            >新增</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="订单编号"
          prop="id"
          height="500"
        />
        <el-table-column
          align="center"
          label="订单名称"
          prop="order_name"
          width="180"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="card_name"
          label="卡牌名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="卡牌正面图片"
        >
          <template #default="{ row }">
            <!-- <img :src="row.front_up" style="width: 100px; height: 100px;" alt=""/> -->
             <el-image 
              style="width: 100px; height: 100px"
              :src="row.front_up" 
              v-if="row.front_up"
              :preview-src-list="[row.front_up]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="total"
          label="订单数量"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="completed_quantity"
          label="已录入数量"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="review_quantity"
          label="已复核数量"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="订单状态"
        >
          <template #default="{ row }">
            <!-- <span>{{ row.status == 1 ? '正常' : '暂停' }}</span> -->
             <span>{{ cardStatus[row.status] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="创建日期"
        >
          <template #default="{ row }">
            <span>{{ transTime(row.insert_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="is_complete"
          label="订单进度"
        >
          <template #default="{ row }">
            <span>{{ row.is_complete == 0 ? '制作中' : '已完成' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="supplier_name"
          label="供应商"
        >
        </el-table-column>
        <el-table-column align="center" label="操作" width="280">
          <template #default="{ row }">
            <el-button
              size="small"
              type="primary"
              v-hasPermi="['Island:chipmanage:edit']"
              @click="handleEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              v-show="row.status == 1"
              size="small"
              type="primary"
              v-hasPermi="['Island:chipmanage:pause']"
              @click="handlePause(row, 2)"
              >
              暂停订单
            </el-button>
            <el-button
              v-show="row.status == 2"
              size="small"
              v-hasPermi="['Island:chipmanage:recover']"
              type="primary"
              @click="handlePause(row, 1)"
              >
              恢复订单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
    <el-dialog
      :title="type === 'add' ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      width="20%"
      :close-on-click-modal="true"
      :before-close="handleClose"
    >
      <el-form
        ref="dialogForm"
        :model="dialogForm"
        label-width="80px"
        :rules="rules"
      >
        <el-form-item label="订单名称" prop="order_name">
          <el-input
            v-model="dialogForm.order_name"
            placeholder="请输入订单名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="卡牌" prop="card">
          <el-select v-model="dialogForm.card" @change="changeSelect" placeholder="请选择卡牌">
            <el-option
              v-for="item in cardList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <div v-if="dialogForm.card" class="img-box">
            <el-image 
              style="width: 100px; height: 100px"
              :src="front_up"
              v-if="front_up"
              :preview-src-list="[front_up]">
            </el-image>
            <el-image 
              style="width: 100px; height: 100px"
              :src="backend_up"
              v-if="backend_up"
              :preview-src-list="[backend_up]">
            </el-image>
            <!-- <img :src="front_up"  class="img-box-one">
            <img :src="backend_up"  class="img-box-two"> -->
          </div>
        </el-form-item>
        <el-form-item label="供应商" prop="card">
          <el-select v-model="dialogForm.supplier_id" @change="changeSupSelect" placeholder="请选择供应商">
            <el-option
              v-for="item in supList"
              :key="item.id"
              :label="item.user_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单数量" prop="order_num">
          <el-input
            v-model="dialogForm.order_num"
            placeholder="请输入订单数量"
          ></el-input>
        </el-form-item>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm('dialogForm')"
            >确认下单</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getSupList, getOrderApi, createOrderApi, getCardList, updateOrderApi, startStopOrderApi, delOrderApi } from '@/api/radio'
import { transTime } from '@/utils/transTime'

export default {
  data() {
    return {
      transTime,
      type: '',
      businessList: [],
      rules: {
        order_name: [{required: true, message: '订单名称不可为空', trigger: 'blur'}],
        card: [{required: true, message: '卡牌不可为空', trigger: 'blur'}],
        order_num: [{required: true, message: '订单数量不可为空', trigger: 'blur'}],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      queryForm: {
        page: 1,
        pageSize: 10,
        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
        dateRange: [], // 时间段
        order_name: '',
        card_name: '',
        is_complete: '',
        status: '',
      },
      completeList: [
        {
          id: 0,
          label: '制作中'
        },
        {
          id: 1,
          label: '已完成'
        }
      ],
      orderList: [
        {
          id: 1,
          label: '启用但未开始'
        },
        {
          id: 2,
          label: '完成'
        },
        {
          id: 3,
          label: '取消'
        },
        {
          id: 4,
          label: '超写'
        },
        {
          id: 5,
          label: '待处理'

        }
      ],
      cardStatus: {
        'ENABLED': '启用但未开始',
        'FINISHED': '完成',
        'DISABLED': '取消',
        'OVERWRITTEN': '超写',
        'INPROGRESS': '待处理'

      },
      dialogVisible: false, // 模态框是否展示
      dialogForm: {
        order_name: '',
        card: '',
        supplier_id: '',
        order_num: null
      }, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
      storeList: [], // 景区列表
      start: '',
      end: '',
      supList: [],
      cardList: [],
      front_up: '',
      backend_up: '',
      card_name: '',
      supplier_name: '',
      is_complete: null,
      id: null,
    };
  },
  created() {
    this.fetchData()
    this.getSupLists()
    this.getCardLists()
  },
  mounted() {},

  methods: {
    getCardLists(){
      let params = {
        page: 1,
        page_size: 100000000000000,
        level: '',
        name: '',
        series_id: -1,
        status: -1
      }
      getCardList(params)
        .then((res) => {
          if (res && res.code) {
            this.cardList = res.data.data_list
            this.total = res.data.total_record
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    changeSelect(val){
      let item = this.cardList.find(item => item.id == val)
      this.front_up = item.front_up
      this.backend_up = item.backend_up
      this.card_name = item.name
    },
    changeSupSelect(val){
      let item = this.supList.find(item => item.id == val)
      this.supplier_name = item.user_name
    },
    getSupLists(){
      let param = {
        user_name: '',
        key: '',
        page: 1,
        page_size: 10000000000
      }
      getSupList(param).then(res => {
        if(res && res.code){
          this.supList = res.data.data_list
        }
      })
    },
    dateChange(val) {
      if(val){
        const [start, end] = val
        this.start = start
        this.end = end
      } else {
        this.start = ''
        this.end = ''
      }
    },
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val
      this.fetchData()
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    handleClose(done) {
      this.clearDialog()
      done()
      this.$refs.dialogForm.resetFields()
    },
    handleQuery() {
      this.queryForm.page = 1;
      this.fetchData();
    },
    handleAdd(){
      this.$refs.dialogForm && this.$refs.dialogForm.resetFields()
      this.clearDialog()
      this.type = 'add'
      this.dialogVisible = true
    },
    async fetchData() {
      console.log('this.queryForm', this.queryForm.is_complete)
      let params = {
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
        order_name: this.queryForm.order_name,
        card_name: this.queryForm.card_name,
        status: this.queryForm.status ? this.queryForm.status : -1,
        is_complete: this.queryForm.is_complete ? this.queryForm.is_complete : -1,
        start: this.start,
        end: this.end
      };
      await getOrderApi(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.data_list
            this.total = res.data.total_record
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleEdit(row, index) {
      this.$refs.dialogForm && this.$refs.dialogForm.clearValidate()
      this.type = 'edit'
      this.id = row.id
      this.is_complete = row.is_complete
      this.dialogVisible = true
      this.dialogForm.card = row.card_id
      this.dialogForm.supplier_id = row.supplier_id
      this.dialogForm.order_name = row.order_name
      this.dialogForm.order_num = row.total
      this.front_up = row.front_up
      this.backend_up = row.backend_up
      this.card_name = row.card_name
      this.supplier_name = row.supplier_name
      this.is_complete = row.is_complete
    },
    submitForm() {
      this.$refs["dialogForm"].validate((valid) => {
        if (valid) {
          if(this.type == 'add'){
            let param = {
              order_name: this.dialogForm.order_name,
              supplier_id: this.dialogForm.supplier_id,
              supplier_name: this.supplier_name,
              card_id: this.dialogForm.card,
              card_name: this.card_name,
              front_up: this.front_up,
              backend_up: this.backend_up,
              total: this.dialogForm.order_num * 1,
            }
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              createOrderApi(param).then(res => {
                if(res.data){
                  this.$message.success('新建成功')
                  this.clearDialog()
                  this.dialogVisible = false
                  this.fetchData()
                }
              })
            })
          } else {
            let param = {
              id: this.id,
              order_name: this.dialogForm.order_name,
              supplier_id: this.dialogForm.supplier_id,
              supplier_name: this.supplier_name,
              card_id: this.dialogForm.card,
              card_name: this.card_name,
              front_up: this.front_up,
              backend_up: this.backend_up,
              total: this.dialogForm.order_num * 1,
              is_complete: this.is_complete,
            }
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              updateOrderApi(param).then(res => {
                if(res.data){
                  this.$message.success('修改成功')
                  this.clearDialog()
                  this.dialogVisible = false
                  this.fetchData()
                }
              })
            })
          }
        }
      })
    },
    handlePause(row, type){
      let param = {
        id: row.id,
        status: type
      }
      startStopOrderApi(param).then(res => {
        if(res.data){
          this.fetchData()
        }
      })
    },
    clearDialog(){
      this.dialogForm = {
        card: '',
        supplier_id: '',
        order_name: '',
        order_num: ''
      }
      this.front_up = ''
      this.backend_up = ''
      this.card_name = ''
      this.supplier_name = ''
      this.is_complete = ''
    }
  },
};
</script>
<style lang="scss" scoped>
.el-select{
  width: 100%;
}

.tableCard {
  margin-top: 20px;
}

.el-pagination {
  text-align: center;
  margin-top: 10px;
}
.img-box{
  display: flex;
  margin: 20px 0;
  img{
    width: 100px;
    height: 100px;
  }
  .img-box-two{
    margin-left: 20px;
  }
}

</style>